import { useEffect, useState } from "react";
import styled from "styled-components";

import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  InputAdornment,
  createFilterOptions,
  Autocomplete,
} from "@mui/material";
import Dialog from "src/components/core/Dialog";
import Button from "src/components/core/Button";
import { IconButton, Stack, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";

import TextField from "src/components/core/TextField";
import LabelSection from "src/components/core/LabelSection";
import MetaTagComponent from "src/modules/exclusive-deal/MataTagComponent";

import font from "src/styles/font";
import { DarkGrey, GreyStroke, White, White01 } from "src/styles/color";

import { useDialog } from "src/context/DialogContext";
import { useSnackbar } from "notistack";

import { updateCategory } from "src/api/landingPage";
import { getSellerListAdmin } from "src/api/seller";
import BannerCategory from "./BannerCategory";

const BoxWrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;

  :last-child {
    margin-bottom: 0;
  }
`;

const S = {};

S.UploadTitle = styled.div`
  font-size: ${font.size.xs};
  font-weight: 400;
  color: ${DarkGrey};
  margin-bottom: 8px;
`;

S.PreviewImageUploadBox = styled.div`
  position: relative;
  width: 100%;
  padding-top: calc(100% / (1250 / 280));
  background-color: ${White01};
  border-radius: 16px;
  /* border: 1px solid ${GreyStroke}; */
  /* grid-column: span 7; */
`;

S.UploadInnerBox = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

S.UploadInput = styled.label`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  padding: 8px;
`;

S.UploadLabel = styled.span`
  font-size: ${font.size.sm};
  font-weight: 500;
  color: ${DarkGrey};
  margin-top: 8px;

  &::after {
    content: "*";
    font-weight: 600;
    color: #e04132;
  }
`;

S.UploadHelperText = styled.span`
  display: flex;
  justify-content: center;
  font-size: ${font.size.xs};
  color: ${DarkGrey};
  text-align: center;
  white-space: pre-line;
  margin-top: 8px;
`;

S.UploadedPreviewImage = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 15px;
  object-fit: cover;
`;

S.BannerListBoxWrapper = styled.div`
  position: relative;
  padding: 24px;
  background-color: ${White01};
  border-radius: 16px;
  margin-top: 24px;
  width: 100%;
  overflow: hidden;
`;

S.BannerListContainer = styled.div`
  width: fit-content;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin: 0 auto;
`;

S.SellerLogoItem = styled.img`
  width: 160px;
  height: 80px;
  border-radius: 16px;
  background: ${White};
  object-fit: contain;
  cursor: pointer;
`;

const ImageEmpty = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: #f2f1f3;
  border-radius: 16px;
  object-fit: cover;
  object-position: center;
  cursor: pointer;
  vertical-align: initial;
  margin-right: 8px;
  &:hover {
    opacity: 0.8;
  }

  &.active {
    border: 2px solid #707070;
  }
`;

const ImgDisplay = styled.img`
  width: 56px;
  height: 56px;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  flex-shrink: 0;
`;

const CategoryEditDialog = ({ initialValue, onClose, onSuccess }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog } = useDialog();

  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 1000,
    status: "all",
  });

  const [sellers, setSellers] = useState([]);

  const [formData, setFormData] = useState(
    {
      ...initialValue,
      brands: initialValue?.brands?.map((brand) => ({
        ...brand?.seller,
      })),
    } ?? {
      cate_th: "",
      cate_en: "",
      banner: null,
      brands: [],
      meta_tag: {
        title: "",
        desc: "",
        img: null,
        keywords: "",
      },
    }
  ); // Mapping initial value to form data

  // const isFormValid = ["cate_th", "cate_en", "banner"].every((required) => {
  //   let objVal = formData?.[required];
  //   return objVal !== null && objVal !== "";
  // });

  const isFormValid = true;

  // const isMetaTagValid = ["title", "desc", "img", "keywords"].every(
  //   (required) => {
  //     let objVal = formData?.meta_tag?.[required];
  //     return objVal !== null && objVal !== "";
  //   }
  // );

  const isMetaTagValid = true;

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formData,
        brands: formData?.brands?.map((brand) => ({ seller: brand?._id })),
        meta_tag: {
          title: formData?.meta_tag?.title,
          desc: formData?.meta_tag?.desc,
          keywords: formData?.meta_tag?.keywords,
        },
        meta_img: formData?.meta_tag?.img,
        banner: formData?.banner,
      };

      // const data = new FormData();
      // for (const field in payload) {
      //   if (field === "meta_tag") {
      //     for (const key in payload.meta_tag) {
      //       data.append(`meta_tag.${key}`, payload.meta_tag[key]);
      //     }
      //   } else {
      //     data.append(field, payload[field]);
      //   }
      // }

      await updateCategory(initialValue?._id, payload); // only update category available

      enqueueSnackbar(`บันทึกสำเร็จ`, {
        variant: "success",
      });

      onSuccess();
    } catch (err) {
      console.error(err);
    }
  };

  const handleSelectSeller = (sellers) => {
    if (sellers.length > 12) {
      enqueueSnackbar(`สามารถเลือกร้านค้าได้ไม่เกิน 12 ร้าน`, {
        variant: "error",
      });
      return;
    }
    setFormData({
      ...formData,
      brands: sellers,
    });
  };

  const fetchPopularSellers = async () => {
    try {
      setIsLoading(true);
      const { data: result } = await getSellerListAdmin({
        ...dataSearch,
        page: 0,
      });

      const _sellers = result?.data?.rows;
      setSellers(_sellers);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPopularSellers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 1024,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle sx={{ p: 3, textAlign: "center" }}>
        แก้ไขหมวดหมู่
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="ชื่อหมวดหมู่สินค้า"
            headerStyle={{ marginBottom: "24px" }}
          >
            <TextField
              label="ชื่อหมวดหมู่สินค้า (ภาษาไทย)"
              variant="outlined"
              required
              value={formData?.cate_th}
              onChange={(e) => {
                setFormData({ ...formData, cate_th: e.target.value });
              }}
              fullWidth
              inputProps={{ maxLength: 100 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {formData?.cate_th?.length}/100
                  </InputAdornment>
                ),
              }}
              error={!formData?.cate_th}
              sx={{
                mb: 3,
              }}
            />
            <TextField
              label="ชื่อหมวดหมู่สินค้า (ภาษาอังกฤษ)"
              variant="outlined"
              required
              value={formData?.cate_en}
              onChange={(e) => {
                setFormData({ ...formData, cate_en: e.target.value });
              }}
              fullWidth
              inputProps={{ maxLength: 100 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {formData?.cate_en?.length}/100
                  </InputAdornment>
                ),
              }}
              error={!formData?.cate_en}
            />
          </LabelSection>
        </BoxWrapper>
        <BannerCategory bannerResource={initialValue?._id} />
        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="แบรนด์สินค้ายอดนิยม"
            headerStyle={{ marginBottom: "24px" }}
          >
            <Autocomplete
              // freeSolo
              multiple
              aria-required={true}
              // getOptionSelected={(option, value) =>
              //   option?._id === value?._id
              // }
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              renderOption={(props, option, { selected }) => (
                <li
                  {...props}
                  key={`item-${option?._id}`}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {!!option?.profile_image === false ? (
                      <ImageEmpty>
                        <InsertPhotoIcon
                          sx={{
                            color: "rgba(0, 0, 0, 0.54)",
                            cursor: "pointer",
                          }}
                        />
                      </ImageEmpty>
                    ) : (
                      <ImgDisplay
                        src={option?.profile_image ? option?.profile_image : ""}
                        alt={option?.profile_image}
                      />
                    )}
                    <Stack style={{ marginLeft: 16 }}>
                      <Typography component="span">
                        {option?.brand_name}
                      </Typography>
                    </Stack>
                  </Box>
                </li>
              )}
              options={sellers}
              value={formData?.brands}
              onChange={(e, newValue) => {
                handleSelectSeller(newValue);
              }}
              onInputChange={(event, newInputValue) => {
                setDataSearch({
                  ...dataSearch,
                  keyword: newInputValue,
                });
              }}
              loading={isLoading}
              disabled={isLoading}
              getOptionLabel={(option) => {
                return option?.brand_name || "--";
              }}
              filterOptions={createFilterOptions({
                matchFrom: "any",
                limit: 100,
              })}
              sx={{
                width: "100%",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  sx={{
                    maxWidth: "100%",
                    width: "100%",
                  }}
                  required
                  placeholder="ค้นหาร้านค้า"
                  helperText="เลือกได้ไม่เกิน 12 ร้าน"
                  // error={!selectedSeller?._id ? true : false}
                />
              )}
            />
            {formData?.brands && formData?.brands?.length !== 0 && (
              <S.BannerListBoxWrapper>
                <S.BannerListContainer>
                  {formData?.brands?.map((seller) => (
                    <S.SellerLogoItem
                      key={seller?._id}
                      src={seller?.icon_homepage ?? seller?.profile_image}
                      alt={seller?.brand_name}
                    />
                  ))}
                </S.BannerListContainer>
              </S.BannerListBoxWrapper>
            )}
          </LabelSection>
        </BoxWrapper>
        <BoxWrapper>
          <LabelSection
            style={{ marginBottom: 0 }}
            title="Metatag"
            headerStyle={{ marginBottom: "24px" }}
          >
            <MetaTagComponent
              keyImg="groupMetaTagFieldHandle"
              metatagData={formData?.meta_tag}
              setMetatagData={(val) =>
                setFormData({
                  ...formData,
                  meta_tag: val,
                })
              }
              isEdit={true}
            />
          </LabelSection>
        </BoxWrapper>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{
            minWidth: 160,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            openDialog({
              type: "confirm",
              title: initialValue
                ? `คุณต้องการยืนยันการแก้ไขใช่หรือไม่`
                : `คุณต้องการเพิ่มหมวดหมู่ใช่หรือไม่?`,
              onConfirm: async () => {
                await handleSubmit();
              },
              maxWidth: 342,
            });
          }}
          sx={{
            minWidth: 160,
          }}
          // autoFocus // enable auto focus to increase accessibility
          disabled={!isFormValid || !isMetaTagValid}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryEditDialog;
